import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PricingService} from '../../service/pricing.service';
import {HttpClient} from '@angular/common/http';
import {WebConfigurationService} from '../../web-configuration-module/web-configuration.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() miniPricerRef: any;
  $search = {
    id: '58bf0bb84cedfd000136eeea',
    fico: 700,
    showDisqualifiedbyRules: false,
    loanPurpose: 'Purchase',
    zip: '91106',
    state: 'CA',
    countyFips: '',
    preferredAmortization: 'Fixed',
    city: 'Pasadena',
    amount: 400000,
    secondLoanAmount: 0,
    downPercent: 20,
    homeValue: 500000,
    ltv: 0.8,
    propertyUse: 'PrimaryResidence',
    propertyType: 'SingleFamily',
    loanCriterias: [
      {
        id: '58bf0bbd4cedfd000136f14c',
        closingCostRange: {
          '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
          closestToPar: false
        },
        selectionType: 'First',
        limit: 3,
        name: '30 Year Fixed',
        mortgageType: 'Conventional',
        loanType: 'Fixed',
        term: 30,
        varaiableLoanType: '_5_1',
        showOnlyIfSecondLoan: false,
        showOnlyIfVASelected: false,
        showWhenEmpty: true,
        ltvRange: {
          '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
          null: true
        },
        noticeConf: {
          closingCostNotices: '',
          productDescription: '',
          disclosure: ''
        },
        limitRates: true,
        showAdjAsLenderCredit: true
      },
      {
        id: '58bf0bbe4cedfd000136f1e1',
        closingCostRange: {
          '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
          closestToPar: false
        },
        selectionType: 'First',
        limit: 3,
        name: '15 Year Fixed',
        mortgageType: 'Conventional',
        loanType: 'Fixed',
        term: 15,
        varaiableLoanType: '_5_1',
        showOnlyIfSecondLoan: false,
        showOnlyIfVASelected: false,
        showWhenEmpty: true,
        ltvRange: {
          '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
          null: true
        },
        noticeConf: {
          closingCostNotices: '',
          productDescription: '',
          disclosure: ''
        },
        limitRates: true,
        showAdjAsLenderCredit: true
      },
      {
        id: '5c7ee2c14cedfd0001a7d319',
        closingCostRange: {
          '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
          closestToPar: false
        },
        selectionType: 'First',
        limit: 3,
        name: '7/1 ARM',
        mortgageType: 'Conventional',
        loanType: 'Variable',
        term: 30,
        varaiableLoanType: '_7_1',
        showOnlyIfSecondLoan: false,
        showOnlyIfVASelected: false,
        showWhenEmpty: true,
        ltvRange: {
          '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
          null: true
        },
        noticeConf: {
          closingCostNotices: '',
          productDescription: '',
          disclosure: ''
        },
        limitRates: true,
        showAdjAsLenderCredit: true
      },
      {
        id: '5d7803e54cedfd00014f6f92',
        closingCostRange: {
          '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
          closestToPar: false
        },
        selectionType: 'FirstLast',
        name: '5/1 Arm',
        mortgageType: 'Conventional',
        loanType: 'Variable',
        term: 30,
        varaiableLoanType: '_5_1',
        showOnlyIfSecondLoan: false,
        showOnlyIfVASelected: false,
        showWhenEmpty: true,
        ltvRange: {
          '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
          null: true
        },
        noticeConf: {
          closingCostNotices: '',
          productDescription: '',
          disclosure: ''
        },
        limitRates: true,
        showAdjAsLenderCredit: true
      }
    ],
    escrowWaiver: false,
    lenderFeeWaiver: false,
    showVA: true,
    secondLoanOption: false,
    lockDays: 30,
    unit: 1,
    ownProperties: 0
  };

  @Input() set search(value) {
    this.$search = value;
    this.$search.showVA = true;
    this.searchForZip(this.search.zip);
  }
  get search() {
    return this.$search;
  }

  @Input() contact = {
    propertyAddress: {
      state: '',
      street: '',
      streetCont: '',
      city: '',
      zip: '',

    },
    firstname: '',
    lastname: '',
    email: '',
    phone: ''
  };

  @Input() searchLabel = 'See My Options';
  @Output() searchEvent: EventEmitter<any> = new EventEmitter();

  loanPurposes = [
    {id: 'Purchase', label: 'Purchase'},
    {id: 'Refinance', label: 'Refinance (R&T)'},
    {
      id: 'StreamLineRefinance', label: 'StreamLine Refinance',
      from: ['UsdaRural', 'FHA', 'VA']
    },
    {id: 'CashoutRefinance', label: 'Cashout refinance'}
  ];
  propertyUses = [
    {id: 'PrimaryResidence', label: 'Primary Residence'},
    {id: 'SecondaryVacation', label: 'Secondary Residence'},
    {id: 'Investment', label: 'Investment (NOO)'}
  ];

  propertyTypes = [
    {id: 'SingleFamily', label: 'Single Family SFR'},
    {id: 'Condos', label: 'Low Rise Attached Condo'},
    {id: 'PlannedUnitDevelopment', label: 'PUD'},
    {id: 'UnitDwelling_2_4', label: '2-4 Unit'},
    {id: 'Modular', label: 'Modular'},
    {id: 'Townhouse', label: 'Townhouse'},
    {id: 'DetachedCondominium', label: 'Detached Condo'},
    {id: 'HighRiseCondo', label: 'High Rise Condo'},
    {id: 'SiteCondo', label: 'Site Condo'},
    {id: 'ManufacturedHousingDoubleWide', label: 'Manufactured Home Double Wide'},
    {id: 'ManufacturedHousingSingleWide', label: 'Manufactured Home Single Wide'},
    {id: 'Cooperative', label: 'Cooperative'},
  ];
  loanTypes = [
    {id: 'Fixed', label: 'Fixed'},
    {id: 'Variable', label: 'Variable'}
  ];
  ficoRange = [
    {id: 760, label: '760+'},
    {id: 740, label: '740 - 759'},
    {id: 720, label: '720 - 739'},
    {id: 700, label: '700 - 719'},
    {id: 680, label: '680 - 699'},
    {id: 660, label: '660 - 679'},
    {id: 640, label: '640 - 659'},
    {id: 620, label: '620 - 639'},
    {id: 600, label: '600 - 619'},
    {id: 580, label: '580 - 599'},
    {id: 560, label: '560 - 579'}

  ];
  zipCodeSearch: string;
  zipCodeSearchPlusCity: string;

  matchingZipList = [];
  zipCodeSelected = {};
  countySelected = {};
  counties = [];
  loadingCounty = false;

  constructor(protected pricingService: PricingService,
              protected http: HttpClient,
              protected configurationService: WebConfigurationService) {

  }

  ngOnInit(): void {
    this.searchForZip(this.search.zip);
  }


  searchForZip(zip) {
    if (zip && zip.length === 5) {
      this.search.zip = zip;
      this.getDetailInfoFromZipCode(zip, data => {
          this.matchingZipList = data;
          if (data && data.length > 0) {
            this.zipCodeSelected = data[0];
            this.zipCodeSearchPlusCity = zip;
            this.zipCodeSearch = zip;
            this.changeCity();
          }
        },
        err => {
        });
    }
  }

  changeCity() {
    this.contact.propertyAddress.city = this.zipCodeSelected['primary_city'];
    this.contact.propertyAddress.state = this.zipCodeSelected['state'];
    this.contact.propertyAddress.zip = this.zipCodeSelected['zip'];
    this.search.city = this.zipCodeSelected['primary_city'];
    if (this.search.state != this.zipCodeSelected['state'] || this.counties.length === 0) {
      this.search.state = this.zipCodeSelected['state'];
      this.getCountyList();
    }
  }

  changeCounty() {
    this.search.countyFips = this.countySelected['code'];
  }
  ucFirstAllWords( str )
  {
    str = str.toLowerCase();
    let pieces = str.split(' ');
    for (let i = 0; i < pieces.length; i++)
    {
      var j = pieces[i].charAt(0).toUpperCase();
      pieces[i] = j + pieces[i].substr(1);
    }
    return pieces.join(' ');
  }
  getCountyList() {
    this.getCountyDataByState(data => {
        this.counties = [];
          let mapTest = {};
          for (let i in data) {
            if (mapTest[(data[i]['stateFips'].length === 1 ? '0' + data[i]['stateFips']: data[i]['stateFips']) + data[i]['countyFips']]) {
              continue;
            }
            mapTest[(data[i]['stateFips'].length === 1 ? '0' + data[i]['stateFips'] : data[i]['stateFips']) + data[i]['countyFips']] = true;
            var c = {
              code: (data[i]['stateFips'].length === 1 ? '0' + data[i]['stateFips'] : data[i]['stateFips']) + data[i]['countyFips'],
              name: this.ucFirstAllWords(data[i]['countyName']),
              displayName: this.ucFirstAllWords(data[i]['countyDisplayName'])
            };
            if (this.zipCodeSelected['countyFps'] === c.code) {
              this.countySelected = c;
              this.changeCounty();
            }
            this.counties.push(c);
          }
          this.loadingCounty = false;
      },
      err => {
      });
  }

  getCountyDataByState(callback: (data) => void, errCallback: (err) => void) {
    this.http.get(
      this.configurationService.configuration.ppeApi
      + 'constant/countys?stateCode=' + this.search.state + '&year=' + new Date().getFullYear()).pipe(
    )
      .subscribe(
        data => callback(data),
        err => errCallback(err),
        () => console.log('request completed')
      );
  }

  getDetailInfoFromZipCode(zipCode: string, callback: (data) => void, errCallback: (err) => void) {
    this.http.get(
      this.configurationService.configuration.ppeApi
      + 'constant/zip/listMiniPricer/' + zipCode).pipe(
    )
      .subscribe(
        data => callback(data),
        err => errCallback(err),
        () => console.log('request completed')
      );
  }

  secondLoanOptionChange() {
    if (!this.search.secondLoanOption) {
      this.search.secondLoanAmount = 0;
    }
  }

  searchPricing() {
    this.searchEvent.emit(true);
  }
}
